import React from 'react';

import { Card, Label } from '@ergeon/core-components';
import { DocumentTextIcon } from '@ergeon/icons/hero/outline';

import type { Activity } from './types';

type ActivityContentProps = {
  activity: Activity;
};

const ActivityContent: React.FC<ActivityContentProps> = ({ activity }) => {
  const { note } = activity;

  if (!note) return null;

  return (
    <Card className="flex flex-col gap-2 p-3" flavor="regular">
      <div className="flex items-center gap-2">
        <DocumentTextIcon className="size-4 text-gray-500 dark:text-gray-600" />
        <Label className="text-gray-500 dark:text-gray-600">Notes</Label>
      </div>
      <p className="text-gray-700 dark:text-gray-400 paragraph-2">{note}</p>
    </Card>
  );
};

export default ActivityContent;
